<template>
  <div>
    <div :class="ProfileStyles.titleWrapper">
      <div
        @click="toggleOpenState(IOData.ownerProfileId, IOData.id)"
        :class="ProfileStyles.profileNameWrapper"
        class="openHandlerWrapper"
      >
        <OpenCloseButton
          :class="ProfileStyles.openCloseButton"
          :groupOpen="groupOpen"
        />
        <div :class="ProfileStyles.name">
          <v-chip outline color="primary" text-color="black" class="label-name"
            >案件</v-chip
          >
          <div :class="ProfileStyles.pointGroupLabel">{{ IOData.name }}</div>
        </div>
      </div>
      <EditOrViewButton
        :permission="IOData.permission"
        :urlPath="
          getUrlPath(
            agencyId,
            IOData.advertiserId,
            IOData.id,
            IOData.ownerProfileId,
          )
        "
      />
    </div>
    <GroupList
      v-if="groupOpen"
      :ownerProfileId="IOData.ownerProfileId"
      :groupList="groupList"
      :groupOpen="groupOpen"
    />
  </div>
</template>

<script>
import OpenCloseButton from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/OpenCloseButton'
import EditOrViewButton from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/EditOrViewButton'
import GroupList from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/PointGroup/GroupList'
import ProfileStyles from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/ProfileStyles'
import {
  getters as pointGroupCatalogGetters,
  actions as pointGroupCatalogActions,
} from '@/vuex/modules/pointGroupCatalog/constants'

export default {
  name: 'IO',
  components: {
    OpenCloseButton,
    EditOrViewButton,
    GroupList,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    IOData: Object,
    agencyId: Number,
    selectedPointGroup: Array,
  },
  data() {
    return {
      groupOpen: false,
    }
  },
  computed: {
    groupList() {
      return this.$store.getters[
        pointGroupCatalogGetters.pointGroupListByOwnerProfileId
      ](this.IOData.ownerProfileId)
    },
    ProfileStyles() {
      return ProfileStyles
    },
  },
  methods: {
    getUrlPath(agencyId, advertiserId, insertionOrderId, ownerProfileId) {
      return `/agencies/${agencyId}/advertisers/${advertiserId}/insertion_orders/${insertionOrderId}/point_groups/${ownerProfileId}`
    },
    async toggleOpenState(ownerProfileId, insertionOrderId) {
      if (!this.groupOpen) {
        await this.$store.dispatch(
          pointGroupCatalogActions.REMOVE_POINT_GROUP_LIST,
          { ownerProfileId },
        )
        if (!this.groupOpen) {
          const belongType = 'insertionOrder'
          const belongId = insertionOrderId
          await this.$store.dispatch(
            pointGroupCatalogActions.SET_POINT_GROUP_LIST,
            { ownerProfileId, belongType, belongId },
          )
        }
      }
      this.groupOpen = !this.groupOpen
    },
  },
}
</script>

<style scoped>
.openHandlerWrapper {
  display: flex;
}
.ioName {
  display: inline-block;
  margin-left: 5px;
}
</style>
